import React from 'react';
import Relay from 'react-relay';

import { ListVertical } from 'depop/components/list';

import CommentListItem from './CommentListItem';


class CommentList extends React.Component {
  props: {
    comments: Object,
  };

  render() {
    const { comments } = this.props;

    return (
      <ListVertical>
        {comments.map((comment) => <CommentListItem key={comment.id} comment={comment} />)}
      </ListVertical>
    );
  }
}

export default Relay.createContainer(CommentList, {
  fragments: {
    comments: () => Relay.QL`
      fragment on ProductComment @relay(plural: true) {
        ${CommentListItem.getFragment('comment')}
        id
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/components/comments/CommentList.js